import { Button } from '#components/atoms/buttons/Button.tsx';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';

type Props = {
  onClose: () => void;
  adminLimit: number;
};

export function TooManyAdminsModal({ onClose, adminLimit }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Account limit reached</ModalHeader>
      <ModalBody>
        <p className="p">
          You’ve reached the maximum limit of {adminLimit} admins. To add another admin, please remove one you no longer
          need, or contact support.
        </p>
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={<Button onClick={onClose}>Close</Button>}
          secondaryButton={
            <LinkButton variant="link" to="/support/contact">
              Contact us
            </LinkButton>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
